module.exports = __webpack_public_path__ + "img/eye-icon.8c644ded.svg";